import { render, staticRenderFns } from "./CorporateDirectoryViewMore.vue?vue&type=template&id=f84c74b4&scoped=true"
import script from "./CorporateDirectoryViewMore.vue?vue&type=script&lang=js"
export * from "./CorporateDirectoryViewMore.vue?vue&type=script&lang=js"
import style0 from "./CorporateDirectoryViewMore.vue?vue&type=style&index=0&id=f84c74b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f84c74b4",
  null
  
)

export default component.exports